export const CURRENT_CHECKOUT_STEP = {
  WARRANTY: 0,
  SHIPPING: 1,
  BILLING: 2,
  REVIEW: 3,
};

export const DEFAULT_SHIPPING_ADDRESS_COUNTRY = 'United States';

export const MAX_PO_ATTACHMENT_SIZE = 33554432;
